export default __webpack_public_path__ + "static/media/replaceIcon.bf7c0b70.svg";